import { createAsyncThunk } from "@reduxjs/toolkit";
import { alertActions } from "./auth/alertSlice";
import axios from "axios";

const backendURL = process.env.REACT_APP_API_URL;

export const getUserDesignation = createAsyncThunk(
  'userDesignation/getData',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const { data } = await axios.get(`${backendURL}/api/userDesignation`,
        config
      )
      return data;
    } catch (error) {
      const errorMessage = error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
      dispatch(
        alertActions.createAlert({
          message: errorMessage,
          type: "warning"
        })
      );
      return rejectWithValue(JSON.stringify(error.response.data.message))
    }
  }
)
export const getReligion = createAsyncThunk(
  'userReligion/getData',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const { data } = await axios.get(`${backendURL}/api/userReligion`,
        config
      )
      return data;
    } catch (error) {
      const errorMessage = error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
      dispatch(
        alertActions.createAlert({
          message: errorMessage,
          type: "warning"
        })
      );
      return rejectWithValue(JSON.stringify(error.response.data.message))
    }
  }
)
export const getUserMarriageState = createAsyncThunk(
  'userMarriageState/getData',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const { data } = await axios.get(`${backendURL}/api/userMarriageState`,
        config
      )
      return data;
    } catch (error) {
      const errorMessage = error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
      dispatch(
        alertActions.createAlert({
          message: errorMessage,
          type: "warning"
        })
      );
      return rejectWithValue(JSON.stringify(error.response.data.message))
    }
  }
)
export const getUserCaste = createAsyncThunk(
  'userCasteState/getData',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const { data } = await axios.get(`${backendURL}/api/userCaste`,
        config
      )
      return data;
    } catch (error) {
      const errorMessage = error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
      dispatch(
        alertActions.createAlert({
          message: errorMessage,
          type: "warning"
        })
      );
      return rejectWithValue(JSON.stringify(error.response.data.message))
    }
  }
)
export const getUserCountry = createAsyncThunk(
  'userCountry/getData',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const { data } = await axios.get(`${backendURL}/api/userCountry`,
        config
      )
      return data;
    } catch (error) {
      const errorMessage = error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
      dispatch(
        alertActions.createAlert({
          message: errorMessage,
          type: "warning"
        })
      );
      return rejectWithValue(JSON.stringify(error.response.data.message))
    }
  }
)
export const getUserDistrict = createAsyncThunk(
  'userDistrict/getData',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const { data } = await axios.get(`${backendURL}/api/userDistrict`,
        config
      )
      return data;
    } catch (error) {
      const errorMessage = error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
      dispatch(
        alertActions.createAlert({
          message: errorMessage,
          type: "warning"
        })
      );
      return rejectWithValue(JSON.stringify(error.response.data.message))
    }
  }
)